import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ActionsAdDiscard from '@adv-mt/mt-actions-ad-discard'
import ActionsAdFavorite, {actionAdFavoriteTrackingOrigins, actionAdFavoriteTypes} from '@adv-mt/mt-actions-ad-favorite'
import ActionsAdShare, {
  actionAdShareButtonAlignment,
  actionAdShareButtonSizes,
  actionAdShareTrackingOrigins,
  actionAdShareTypes
} from '@adv-mt/mt-actions-ad-share'
import {useShareApi} from '@adv-mt/mt-hook-use-share-api'

const BASE_CLASS = 'mt-CardAd-menu'
const ITEM_CLASS = `${BASE_CLASS}Item`

const CardAdMenu = ({
  ad,
  discardedAdsProps,
  extendedTrackingData,
  isDiscardedAdsEnabled,
  isFavorite,
  onToggleFav = () => {},
  trackingData,
  updatePosition = () => {}
}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')

  const {IS_PRICE_DROP_BUTTON_ENABLED} = config.get('favorites') || false
  const isSubscriptionAd = Boolean(ad.monthlySubscriptionFee)

  const handleOnClickPriceDropButton = nextFavoriteState => {
    onToggleFav(nextFavoriteState)
    updatePosition()
  }

  const {canShare: isNativeShareAvailable} = useShareApi()
  const isMobile = config.get('isMobile')

  const companyUrl = config.get('COMPANY_URL')
  const referrer = `${companyUrl}${ad.url}`

  return (
    <ul className={BASE_CLASS}>
      {isDiscardedAdsEnabled && (
        <li className={ITEM_CLASS}>
          <ActionsAdDiscard {...discardedAdsProps} />
        </li>
      )}
      {isNativeShareAvailable && isMobile && (
        <li className={ITEM_CLASS}>
          <ActionsAdShare
            alignment={actionAdShareButtonAlignment.LEFT}
            ad={ad}
            extendedTrackingData={extendedTrackingData}
            referer={referrer}
            size={actionAdShareButtonSizes.LARGE}
            trackingOrigin={actionAdShareTrackingOrigins.ADS_LIST_MENU_AD_SHARED}
            type={actionAdShareTypes.MENU_BUTTON}
          />
        </li>
      )}

      {IS_PRICE_DROP_BUTTON_ENABLED && !isSubscriptionAd && !isFavorite ? (
        <li className={ITEM_CLASS}>
          <ActionsAdFavorite
            ad={ad}
            extendedTrackingData={extendedTrackingData}
            isFavorite={isFavorite}
            onClick={handleOnClickPriceDropButton}
            trackingData={trackingData}
            trackingOrigin={actionAdFavoriteTrackingOrigins.LIST_MENU_AD_FAVORITED_PRICEDROP}
            type={actionAdFavoriteTypes.PRICE_DROP_MENU_BUTTON}
          />
        </li>
      ) : null}
    </ul>
  )
}

CardAdMenu.displayName = 'CardAdMenu'

CardAdMenu.propTypes = {
  ad: PropTypes.object.isRequired,
  discardedAdsProps: PropTypes.shape({
    adId: PropTypes.string.isRequired,
    isFavorite: PropTypes.bool.isRequired,
    onAfterDiscard: PropTypes.func.isRequired,
    origin: PropTypes.string.isRequired
  }).isRequired,
  extendedTrackingData: PropTypes.object,
  isDiscardedAdsEnabled: PropTypes.bool.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  onToggleFav: PropTypes.func,
  trackingData: PropTypes.object,
  updatePosition: PropTypes.func
}

export default CardAdMenu
